/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_WildlifeInputs */

const en_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wildlife`)
};

const es_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vida silvestre`)
};

const fr_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faune`)
};

const de_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tierwelt`)
};

const ja_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`野生動物`)
};

const zh_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`野生动物摄影`)
};

const ar_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تصوير حياة برية`)
};

const id_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Satwa Liar`)
};

const it_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Natura / Fauna`)
};

const ru_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Дикая природа`)
};

const pt_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vida Selvagem`)
};

const ko_val_wildlife = /** @type {(inputs: Val_WildlifeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`야생 동물`)
};

/**
* | output |
* | --- |
* | "Wildlife" |
*
* @param {Val_WildlifeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_wildlife = /** @type {((inputs?: Val_WildlifeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_WildlifeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_wildlife(inputs)
	if (locale === "es") return es_val_wildlife(inputs)
	if (locale === "fr") return fr_val_wildlife(inputs)
	if (locale === "de") return de_val_wildlife(inputs)
	if (locale === "ja") return ja_val_wildlife(inputs)
	if (locale === "zh") return zh_val_wildlife(inputs)
	if (locale === "ar") return ar_val_wildlife(inputs)
	if (locale === "id") return id_val_wildlife(inputs)
	if (locale === "it") return it_val_wildlife(inputs)
	if (locale === "ru") return ru_val_wildlife(inputs)
	if (locale === "pt") return pt_val_wildlife(inputs)
	return ko_val_wildlife(inputs)
});